import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {TicketService} from "../../../../../service/api/ticket.service";
import {TicketActionAvailableResponseDto} from "../../../../../model/dto/api/ticket-action-available-response.dto";
import {TicketActionDto} from "../../../../../model/dto/entity/ticket-action.dto";
import {TicketActionAvailableDto} from "../../../../../model/dto/api/ticket-action-available.dto";
import {TicketActionService} from "../../../../../service/api/ticket-action.service";
import {forkJoin} from "rxjs";
import {TmTicketTypeActionInternalTypeEnum} from "../../../../../enum/tm-ticket-type-action-internal-type.enum";
import {UiAvailableActions} from "./data/ui-available-actions";
import {MvsMessageService} from "../../../../../../../core/shared/service/message/mvs-message.service";

@Component({
    selector: 'tm-ticket-select-predefine-task',
    templateUrl: './tm-ticket-select-predefined-task.component.html',
    styleUrls: ['./tm-ticket-select-predefined-task.component.scss'],
    standalone: false
})
export class TmTicketSelectPredefinedTaskComponent implements OnInit, OnChanges, OnDestroy {

    @Input() ticketId: number;
    @Input() availableActionsResponse: TicketActionAvailableResponseDto;
    @Output() onCreateAction = new EventEmitter<boolean>();
    protected readonly TmTicketTypeActionInternalTypeEnum = TmTicketTypeActionInternalTypeEnum;

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    tasks = [
        {name: 'Complete Customer Onboarding', completed: false},
        {name: 'Renew Customer Contract', completed: false},
        {name: 'Change Customer Contact Data', completed: true},
        {name: 'Process name here', completed: false},
        {name: 'Process name here', completed: false},
    ];
    uiAvailableActions: UiAvailableActions[];

     actionLabelMap: Record<string, string> = {
        user_defined: 'benutzerdefiniert',
        simple: 'einfach',
        ticket: 'Ticket',
        process: 'Verfahren',
        notification: 'Benachrichtigung',
        appointment: 'Termin'
    };

    constructor(protected ticketService: TicketService,
                protected ticketActionService: TicketActionService,
                protected messageService: MvsMessageService) {
    }

    ngOnInit(): void {
        this.initComponent();
        this.refreshComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {

        for (let action of this.availableActionsResponse.availableActions) {
            action.selected = false;
        }

    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.prepareUiActions();
        this.initialized = true;
    }

    prepareUiActions() {
        this.uiAvailableActions = [];

        if (!this.availableActionsResponse || !this.availableActionsResponse.availableActions?.length) {
            return;
        }

        for (let item of this.availableActionsResponse.availableActions) {

            if (item.ticketTypeAction.internalType == TmTicketTypeActionInternalTypeEnum.user_defined) {
                continue; //not interested in user defined
            }

            const exists = this.uiAvailableActions.find(value => value.actionType == item.ticketTypeAction.internalType);

            if (exists) {
                continue;
            }

            const entries = this.availableActionsResponse.availableActions.filter(c => c.ticketTypeAction.internalType == item.ticketTypeAction.internalType);

            // Sort by orderPriority descending (1000001208)
            entries.sort((a, b) => (b?.ticketTypeAction?.orderPriority ?? 0) - (a?.ticketTypeAction?.orderPriority ?? 0));

            const uiAction = new UiAvailableActions();
            uiAction.actionType = item.ticketTypeAction.internalType;
            uiAction.availableActions = entries;
            let label = TmTicketTypeActionInternalTypeEnum[uiAction.actionType];
            label = this.actionLabelMap[label] ?? label;
            uiAction.label = label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();

            this.uiAvailableActions.push(uiAction);
        }

        // Sort uiAvailableActions by highest orderPriority in each group (descending)
        this.uiAvailableActions.sort((a, b) => {
            const maxPriorityA = a.availableActions[0]?.ticketTypeAction?.orderPriority ?? 0;
            const maxPriorityB = b.availableActions[0]?.ticketTypeAction?.orderPriority ?? 0;
            return maxPriorityB - maxPriorityA;
        });

        console.log(this.uiAvailableActions);


    }

    handleClickTicketAction() {
        if (this.busy) {
            return;
        }

        this.busy = true;
        const createActions = [];

        for (let action of this.availableActionsResponse.availableActions) {
            if (action.selected) {
                const dto = new TicketActionDto();
                dto.ticketDtoId = this.ticketId;
                dto.ticketTypeActionDtoId = action.ticketTypeAction.id;
                dto.ticketObjectDtoId = action.ticketObject?.id;
                createActions.push(this.ticketActionService.create(dto));
            }
        }

        if (createActions.length > 0) {
            forkJoin(createActions).subscribe(responses => {
                this.messageService.showSuccessMessage('', 'Ticket Action Created!');
                this.handleObjectCreationFinished();
                this.busy = false;
            }, error => {
                this.busy = false;
            });
        } else {
            this.busy = false;
        }
    }

    handleObjectCreationFinished() {
        this.onCreateAction.emit(true);
    }


    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        this.refreshComponent();
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }

    taskSelection(task: TicketActionAvailableDto) {
        task.selected = !task.selected;
    }

    onCheckboxChange(task: TicketActionAvailableDto, event: any) {
        task.selected = event.checked;  // PrimeNG sends checked state
    }
}
